// Copyright (c) 2022 by Move Closer

export const DEFAULT_DRAWER_TITLE = 'Modal title'
export const DEFAULT_DRAWER_CLOSE_ON_CLICK_OUTSIDE_STATUS = true
export const DEFAULT_DRAWER_BACKDROP_STATUS = true
export const DEFAULT_DRAWER_POSITION = 'right'

export enum DrawerLayout {
  Full = 'full',
  Partial = 'partial'
}
